setTimeout(() => {
  const waitForSwiper = setInterval(() => {
    const el = document.querySelector('.product__media-container.below-mobile.carousel');
    if (el && el.swiper) {
      clearInterval(waitForSwiper);
      el.swiper.on('slideChangeTransitionEnd', () => {
        document.querySelectorAll('.plyr__control').forEach(btn => {
          btn.classList.add('show-btn');
        });
      });
      document.addEventListener('click', function (e) {
        console.log(e);
        if (e.target.classList.contains('plyr__control')) {
          e.target.classList.remove('show-btn');
        }
      });
      document.querySelectorAll('.plyr__control').forEach(btn => {
        btn.classList.add('show-btn');
      });
    }
  }, 300);
}, 1500);
